namespace Matrix.Indexation {
    export interface FactIndexPriceRow {
        IndexationProfileKey?: number;
        IndexKey?: number;
        PriceTypeCode?: string;
        PriceDate?: string;
        IndexPrice?: number;
        SourceCode?: string;
        IndexPriceCurrency?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        IndexCode?: string;
        IndexName?: string;
        IndexGeneration?: number;
        IndexIsCurrent?: string;
        IndexEffectiveFrom?: string;
        IndexEffectiveTo?: string;
        IndexLocalCurrencyCode?: string;
        IndexTypeCode?: string;
        IndexPriceSource1?: string;
        IndexPriceSource1Id?: string;
        IndexPriceSource2?: string;
        IndexPriceSource2Id?: string;
        IndexFxOtherCurrency?: string;
        IndexRowId?: number;
        IndexDefaultSortOrder?: number;
        SourceName?: string;
        SourceGroup?: string;
        SourceCategory?: string;
        SourceId?: number;
        SourceRowId?: number;
        IndexPriceCurrencyName?: string;
        IndexPriceCurrencyRowId?: number;
        IndexPriceCurrencyDefaultSortOrder?: number;
    }

    export namespace FactIndexPriceRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Indexation.FactIndexPrice';
        export const deletePermission = 'DataAdmin:FactIndexPrice';
        export const insertPermission = 'DataAdmin:FactIndexPrice';
        export const readPermission = 'Read:FactIndexPrice';
        export const updatePermission = 'DataAdmin:FactIndexPrice';

        export declare const enum Fields {
            IndexationProfileKey = "IndexationProfileKey",
            IndexKey = "IndexKey",
            PriceTypeCode = "PriceTypeCode",
            PriceDate = "PriceDate",
            IndexPrice = "IndexPrice",
            SourceCode = "SourceCode",
            IndexPriceCurrency = "IndexPriceCurrency",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            IndexCode = "IndexCode",
            IndexName = "IndexName",
            IndexGeneration = "IndexGeneration",
            IndexIsCurrent = "IndexIsCurrent",
            IndexEffectiveFrom = "IndexEffectiveFrom",
            IndexEffectiveTo = "IndexEffectiveTo",
            IndexLocalCurrencyCode = "IndexLocalCurrencyCode",
            IndexTypeCode = "IndexTypeCode",
            IndexPriceSource1 = "IndexPriceSource1",
            IndexPriceSource1Id = "IndexPriceSource1Id",
            IndexPriceSource2 = "IndexPriceSource2",
            IndexPriceSource2Id = "IndexPriceSource2Id",
            IndexFxOtherCurrency = "IndexFxOtherCurrency",
            IndexRowId = "IndexRowId",
            IndexDefaultSortOrder = "IndexDefaultSortOrder",
            SourceName = "SourceName",
            SourceGroup = "SourceGroup",
            SourceCategory = "SourceCategory",
            SourceId = "SourceId",
            SourceRowId = "SourceRowId",
            IndexPriceCurrencyName = "IndexPriceCurrencyName",
            IndexPriceCurrencyRowId = "IndexPriceCurrencyRowId",
            IndexPriceCurrencyDefaultSortOrder = "IndexPriceCurrencyDefaultSortOrder"
        }
    }
}
